import React, { CSSProperties } from 'react';

interface CurveLabelCircleProps {
	className?: string;
	style?: CSSProperties;
}

const CurveLabelCircle = ({ className, style }: CurveLabelCircleProps) => (
	<svg viewBox='0 0 10 10' className={className} style={style}>
		<circle cx='5' cy='5' r='4.2' />
	</svg>
);

export default CurveLabelCircle;
